import { useDispatch } from 'react-redux'
import { deleteMapByIdMutation, useMapsDeleting } from '~workspace/states/maps'

const useDeleteMapById = () => {
  const dispatch = useDispatch()

  const deleting = useMapsDeleting()

  const deleteMapById = async (mapId) => {
    dispatch(deleteMapByIdMutation({ byId: mapId }))
  }

  return { deleting, deleteMapById }
}

export { useDeleteMapById }
export default useDeleteMapById
